module.exports = __webpack_public_path__ + "img/pic_start_coinsale2@2x.a64a82f9.png";